var CalendarFilter = function () {
    //getTimeInSeconds
    //
    //@param {array} time parts array where the first element is
    //  a hours, second id a minutes and the last is a seconds
    //
    //@return {number} time in seconds
    //
    //@description
    //Converts time to seconds
    function getTimeInSeconds(timeParts) {
        var multiplexor = 3600,
            result = 0;
        timeParts.forEach(function (el) {
            result += parseInt(el) * multiplexor;
            multiplexor /= 60;
        });
        return result;
    }

    //filter main function
    //
    //@param {Array} array to filter
    //@param {Object} filter condition
    //
    //@description
    //This function filters passed array by given object. The object to filter the array
    //should have the next fields
    // - beginTime {string} time in iso_8601 format
    // - endTime {string} time in iso_8601 format
    // As the result function returns array of the values that satisfy the
    // condition value.time > beginTime and vaule.time < endtime 
    // and value.time before fieldendTime, which is calculated by cutOff time and endTime of the day.
    return function (input, interval, fieldtime, fieldendTime, format) {
        if (!interval) {
            return input.filter(function (el) {
                if (el[fieldendTime]) {
                    if (moment(el[fieldtime]).isBefore(moment(el[fieldendTime]))) {
                        return input;
                    }
                }
                else {
                    return input;
                }
            });
        } else {
            return input.filter(function (el) {
                if (el[fieldendTime]) {
                    if ((moment(el[fieldtime])).isBefore(moment(el[fieldendTime]))) {
                        return moment(moment(el[fieldtime], format).format('HH:mm:ss'), 'HH:mm:ss')
                            .isBetween(
                                moment(interval.beginTime, 'HH:mm:ss'),
                                moment(interval.endTime, 'HH:mm:ss'),
                                null, '[]');
                    }
                }
                else {
                    return moment(moment(el[fieldtime], format).format('HH:mm:ss'), 'HH:mm:ss')
                        .isBetween(
                            moment(interval.beginTime, 'HH:mm:ss'),
                            moment(interval.endTime, 'HH:mm:ss'),
                            null, '[]');
                }
            });
        }
    };
};

module.exports = CalendarFilter;
